import { useIncident, useIsInitialResponse } from './hooks/incidentHooks';
import { useIncidentInfo } from './hooks/incidentInfoHooks';
import IAPDashboardNew from './IAPDashboardNew';
import InitialResponsePage from './initialResponsePage/InitialResponsePage';
import { useIncidentRoster } from './hooks/incidentRoster/useIncidentRoster';

const IAPDashboard = () => {
  // trigger preloaded fetches
  useIncidentRoster();
  useIncidentInfo();

  const incident = useIncident();

  // Period 0 alone no longer means initial response: an escalated incident stays on period 0 while its first Planning P
  // cycle prepares period 1, and that cycle belongs in the Planning P dashboard.
  const isInitialResponse = useIsInitialResponse();

  if (incident.data === undefined) {
    return null;
  }

  return isInitialResponse ? <InitialResponsePage /> : <IAPDashboardNew />;
};

export default IAPDashboard;
